/**
 * 教学点管理控制器
 */
export default class TeachingPointController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/teachingPoint/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/teachingPoint/view', 'get', params, axiosOption, httpOption);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/teachingPoint/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/teachingPoint/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/teachingPoint/delete', 'post', params, axiosOption, httpOption);
  }

  /**
   * 导入教学点数据
   * @param {Object} sender - 发送器对象
   * @param {Object} params - 请求参数（包含FormData）
   * @param {Object} axiosOption - axios配置
   * @param {Object} httpOption - HTTP配置
   * @returns {Promise} - 请求结果
   */
  static importData (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/teachingPoint/import', 'post', params, axiosOption, httpOption);
  }
}
